import { add_new_db_connection, create_bot_Combine_logo, create_db_bot, create_db_bot_logo, edit_db_connection, get_DB_connections, get_sample_db_connection, insert_sample_database_into_dbconnection } from "../../helpers/fakebackend_helper";
import { create_bot_set_start_loader, create_bot_sucess } from "../Create_New_bot/reducer";
import { open_success_modal } from "../Success_Modal/reducer";
import { Create_Bot_Database_Structure, Create_New_Bot } from "../thunks";
import { close_add_db_modal, close_select_db_modal, fetch_db_list_fail, fetch_db_list_success, save_new_db_connection_fail, save_new_db_connection_success, set_sample_db_connection_fail, set_sample_db_connection_success, start_db_connection_modal_loading } from "./reducer";

export const Save_New_DB_Connection = (filterData , history) => async (dispatch) => {

// console.log("Calling Save_New_DB_Connection" , filterData);


  try {
    let response;
   
 
    




    dispatch(start_db_connection_modal_loading())
    
 
      response = add_new_db_connection(filterData);
    
    
    var api_resposne = await response;







      

        dispatch(save_new_db_connection_success(api_resposne.connection.Database_ID));
      
        

        if(filterData.pathname ==='/Group_Dashboard'){
          dispatch(GET_DB_Connection({group_id:filterData.Group_ID}))
          dispatch(open_success_modal("Database connection saved !!!!"));
          return
        }
       
        
         
        dispatch(start_db_connection_modal_loading())
        
      
   
        
        const data = new FormData()
        
        
        data.append('Group_ID',filterData.Group_ID)
        data.append('Max_Record',filterData.max_record)
        data.append('Bot_Allow_See_Source', filterData.bot_allow_see_source)
        data.append('BOT_Category',filterData.BOT_Category)
        data.append('Bot_Sample_Question',filterData.Bot_Sample_Question)
        data.append('Model',filterData.model)
        data.append('Bot_Instructions',filterData.instructions)
        data.append('Bot_Title',filterData.title)
        data.append('Bot_Description',filterData.description)
        data.append('structure',"[]")
        data.append('Database_ID',api_resposne.connection.Database_ID)
        data.append('Bot_Logo' , filterData.logo)
        data.append('Type','DBLink')
        data.append('Query_Model',filterData.Query_Model)
        // console.log("Creating bot with saved Data");
        
        dispatch(create_bot_set_start_loader())
        
        
        // response = create_db_bot_logo(data);

 

            

       let  create_bot = create_bot_Combine_logo(data)

      

        
        
        
        
        var api_response_ = await create_bot;

  
        dispatch(create_bot_sucess(api_response_));

        dispatch(close_add_db_modal())
        dispatch(close_select_db_modal())


        history('/Configuration')

       

   
    
  } catch (error) {
    dispatch(save_new_db_connection_fail(error));
  }
};

export const GET_DB_Connection = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
  
  
  
      dispatch(start_db_connection_modal_loading())
      
   
        response = get_DB_connections(filterData);
      
      
      var api_resposne = await response;
  
  
  
  
  
  
  
        
  
          dispatch(fetch_db_list_success(api_resposne));
  
     
      
    } catch (error) {
      dispatch(fetch_db_list_fail(error));
    }
  };



  export const Edit_DB_Connection = (filterData , history) => async (dispatch) => {
  //  console.log("Calling edit_db_connection");
   


    try {
      let response;
  
  
  
  
  
      dispatch(start_db_connection_modal_loading())
      
   
        response = edit_db_connection(filterData);
      
      
       await response;
  
  
  
  
  
  
  
        
  
          dispatch(save_new_db_connection_success(filterData.database_id));
          dispatch(open_success_modal("Database details updated !!!!"));
          dispatch(GET_DB_Connection({group_id:filterData.group_id}))
  
  
          
  
     
      
    } catch (error) {
      console.log(error);
      dispatch(save_new_db_connection_fail(error));
    }
  };


  export const GET_Sample_Db_Connection_List = (filterData , history) => async (dispatch) => {

    
 
 
     try {
       let response;
       
       response = get_sample_db_connection()

       const sample_db_list = await response

      //  console.log(sample_db_list);

       dispatch(set_sample_db_connection_success(sample_db_list.sample_db_list))
       

       
     } catch (error) {
       console.log(error);
       dispatch(set_sample_db_connection_fail(error));
     }
   };

   export const Insert_Sample_Db_Connection_In_Group = (filterData , history) => async (dispatch) => {

    
 
 
    try {
      let response;
      
      response = insert_sample_database_into_dbconnection(filterData)

      const sample_db_list = await response

   


      dispatch(GET_DB_Connection({
        group_id:filterData.Group_ID,
      }))
      

      
    } catch (error) {
      console.log(error);
      dispatch(set_sample_db_connection_fail(error));
    }
  };


   
 




  

